import React, {useEffect} from "react";
import {Card, CardBody, Pagination} from "../../../../../_metronic/_partials/controls";
import { Filter } from "./Filter";
import {shallowEqual, useDispatch, useSelector} from "react-redux";
import {useMetadata} from "../../../../../_emywork/AEPagination";
import {CONTEXT} from "../../helpers/ModuleHelpers";
import {actionTypes} from "../../_redux/slice";
import {fetchEntities} from "../../_redux/actions";
import {EntityCard} from "../../componants/EntityCard";
import {AESpinner} from "../../../../../_emywork/spinner/AESpinner";
import * as actions from "../../_redux/actions";
import {AddToTeamModal} from "../../dialogs/addToTeamModal";

export function List() {
  const dispatch = useDispatch();

  const { entities, meta, isLoading } = useSelector(
    state => state[CONTEXT][actionTypes.List]
    , shallowEqual )
  const metadata = useMetadata(meta);
  const { page, perPage, sortAsc, filters, sortField, select } = metadata;

  const getEntities = () => {
    dispatch(fetchEntities(metadata.toAEMetadata()));
  }

  useEffect(() => {
    getEntities()
  }, [dispatch, page, perPage, filters, select, sortField, sortAsc]);

  return (
    <>
      <Filter {...metadata} isLoading={isLoading}/>

      {
        isLoading ?
          <Card>
            <CardBody className="text-center">
              <AESpinner />
            </CardBody>
          </Card>:
          <div className={'row'}>
          {
            entities.map(r=>(
              <div key={r.id} className={`col-xl-3 col-lg-4 col-md-4 col-sm-6 ${r.is_private === 1 ? 'd-none' : ''}`}>
                <EntityCard key={r.id} entity={r} size={"md"} detailsAction
                  onUpdate={()=>{
                    dispatch(actions.toggleSave(r.id, !r.is_saved, actionTypes.List))
                  }}
                />
              </div>
            ))
          }
          </div>

      }
      <Pagination
        {...metadata}
        counts={[12, 24, 48, 96]}
      />
    </>
  );
}
